import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = ".kof-link {\n  color: #0d6efd;\n  text-decoration: none;\n}\n.kof-link:hover {\n  color: #0a58ca;\n}";
  const fileName = "Link_Link_5b164dff-1c40-4597-a5bf-da5c400209ec";
  const element = document.querySelector("style[data-sass-component='Link_Link_5b164dff-1c40-4597-a5bf-da5c400209ec']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function Link(props) {
  const nativeProps = {
    className: 'kof-link'
  };
  if (typeof props.target === 'function') {
    nativeProps.href = '#';
    nativeProps.onClick = event => {
      event.preventDefault();
      props.target();
    };
  }
  if (typeof props.target === 'string') {
    nativeProps.href = props.target;
    if (props.newPage || props.target.startsWith('http')) {
      nativeProps.target = '_blank';
    }
  }
  return /*#__PURE__*/_jsx("a", {
    ...nativeProps,
    children: props.children
  });
}
Link.propTypes = {
  target: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
  newPage: PropTypes.bool
};
export { Link };